import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_164: DocMigration = {
  maxSchemaVersion: "0.0.164",
  description: "Window refactor: window panel type, glazing type, glazing color",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];

      //catalog windows updates
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const typeId in setting.windowTypes) {
          const windowDescriptor = setting.windowTypes[typeId];

          //consolidate fields to panelType
          let panelType = "GLAZING";

          const screen = windowDescriptor.screen;
          const vented = windowDescriptor.vented;
          const fauxShutter = windowDescriptor.fauxShutter;

          if (screen) {
            panelType = "SCREEN";
          }
          if (vented) {
            panelType = "VENT";
          }
          if (fauxShutter) {
            panelType = "FAUX_SHUTTER";
          }

          windowDescriptor["panelType"] = panelType;

          if (screen !== undefined) {
            delete windowDescriptor.screen;
          }
          if (vented !== undefined) {
            delete windowDescriptor.vented;
          }
          if (fauxShutter !== undefined) {
            delete windowDescriptor.fauxShutter;
          }

          //glazingType field
          const tempered = windowDescriptor.tempered;

          let glazingType = "STANDARD";
          if (tempered) {
            glazingType = "TEMPERED";
            delete windowDescriptor.tempered;
          }

          windowDescriptor["glazingType"] = glazingType;

          //glazingColor field
          windowDescriptor["glazingColor"] = "CLEAR";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_164;
